module.exports = __webpack_public_path__ + "img/11.f7b01f26.jpg";